import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
// import "../assets/css/navbar-modern.css";

import biswa from "../assets/img/biswa.png";
import logoPms from "../assets/img/logo_pms.png";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const getNavLinkClass = ({ isActive }) =>
    `citizen-navbar-link ${isActive ? "is-active" : ""}`;

  return (
    <header className="citizen-navbar">
      <div className="citizen-navbar-brand-area">
        <div className="citizen-navbar-brand-container">
          <div className="citizen-navbar-portal-brand">
            <img
              src={logoPms}
              alt="Panchayat Management System"
              className="citizen-navbar-portal-logo"
            />
          </div>

          <div className="citizen-navbar-citizen-badge">
            <span className="citizen-navbar-citizen-icon">
              <i className="fa-solid fa-user-shield" />
            </span>

            <div>
              <small>Citizen Services</small>
              <strong>Certificate Portal</strong>
            </div>
          </div>
        </div>
      </div>

      <div className="citizen-navbar-menu-area">
        <div className="citizen-navbar-menu-container">
          <div className="citizen-navbar-mobile-title">
            <span>
              <i className="fa-solid fa-certificate" />
            </span>

            <div>
              <small>Citizen Corner</small>
              <strong>Certificate Services</strong>
            </div>
          </div>

          <button
            type="button"
            className={`citizen-navbar-toggle ${isMenuOpen ? "is-open" : ""
              }`}
            onClick={() => setIsMenuOpen((current) => !current)}
            aria-label={isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={isMenuOpen}
            aria-controls="citizen-certificate-navigation"
          >
            <span />
            <span />
            <span />
          </button>

          <nav
            id="citizen-certificate-navigation"
            className={`citizen-navbar-links ${isMenuOpen ? "is-open" : ""
              }`}
            aria-label="Certificate services navigation"
          >
            <NavLink
              to="/add-certificate"
              className={getNavLinkClass}
              onClick={closeMenu}
            >
              <span className="citizen-navbar-link-icon">
                <i className="fa-solid fa-file-circle-plus" />
              </span>

              <span className="citizen-navbar-link-copy">
                <strong>Apply Certificate</strong>
                <small>Submit a new application</small>
              </span>
            </NavLink>

            <NavLink
              to="/certificate-list"
              className={getNavLinkClass}
              onClick={closeMenu}
            >
              <span className="citizen-navbar-link-icon">
                <i className="fa-solid fa-list-check" />
              </span>

              <span className="citizen-navbar-link-copy">
                <strong>Application Status</strong>
                <small>Track and download certificates</small>
              </span>
            </NavLink>
          </nav>

          {/* <div className="citizen-navbar-help">
            <span>
              <i className="fa-solid fa-circle-info" />
            </span>

            <div>
              <small>Need assistance?</small>
              <strong>Citizen Help Desk</strong>
            </div>
          </div> */}
        </div>
      </div>

      {isMenuOpen && (
        <button
          type="button"
          className="citizen-navbar-overlay"
          onClick={closeMenu}
          aria-label="Close navigation menu"
        />
      )}
    </header>
  );
};

export default Navbar;
